<template>
  <ModalLayout icon="delete" title="Delete file?" @close="close">
    Are you sure you want to delete <strong>'{{ meta?.file?.name }}'</strong>? This action cannot be undone.
    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" @click="ctaDelete" :loading="loading" icon="el-icon-delete" type="danger">Delete</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'
export default {
  name: 'DeleteFile',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaDelete() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/deleteFile', {
        file_id: this.meta?.file?.id,
      })
      this.$Modal.bus.$emit('reload:creative')
      this.close()
      this.loading = false
    },
  },
}
</script>
